/**
 * Stand-in for URL.canParse until support for Safari 16 is dropped.
 */
export const canParse = (url: string): boolean => {
  if ('canParse' in URL) {
    return URL.canParse(url)
  }

  try {
    new window.URL(url)
    return true
  } catch {
    return false
  }
}
